import {connect} from "react-redux";
import V2OpportunityActivity from "./NextActivity";
import {bindActionCreators} from "redux";
import {dropdownData, getV2OpportunityActivities, getLastLeadOpportunityActivities} from "../../../../service/Account/action";
import {documentUploadUrl} from "../../../../service/fileUpload/action";
import {saveActivity} from "../../../../service/DCC/action";
import {markAttendance} from "../../../../service/DCC/action";
import {isUserCheckInForModule} from "../../../../service/Account/action";
import {documentUploadUrlPublic} from "../../../../service/fileUpload/action";
import {accountDetailsById} from "../../../../service/Account/action";
import {getOpportunity} from "../../../../service/Opportunities/action";
import {getSenior} from "../../../../service/Dealer/action";
import {getSelectedTaggedAlong} from "../../../../service/Activity/action";
import {taggedAlongById} from "../../../../service/Dealer/action";
import {errorLogs} from "../../../../service/FasttagToll/action";

const mapStateToProps = (state) => ({
    dropdownValue:state.Dropdown.dropdownValue,
    userCheckInForModule:state.Dropdown.userCheckInForModule,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    leadOpportunityActivity:state.Dropdown.leadOpportunityActivity,
    LastLeadOpportunityActivity:state.Dropdown.LastLeadOpportunityActivity,
    saveActivityRes:state.DCC.saveActivityRes,
    attendance:state.DCC.attendance,
    accountDetails:state.Dropdown.accountDetailsById,
    opportunityDetails:state.Opportunitie.opportunityDetails,
    senior: state.Dealer.senior,
    selectedTaggedAlongResponse:state.Activity.selectedTaggedAlongResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            dropdownData,
            getV2OpportunityActivities,
            documentUploadUrl,
            saveActivity,
            getLastLeadOpportunityActivities,
            markAttendance,
            isUserCheckInForModule,
            documentUploadUrlPublic,
            accountDetailsById,
            getOpportunity,
            getSenior,
            getSelectedTaggedAlong,
            errorLogs
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(V2OpportunityActivity);
